import importer from "common/importer";

const getAllCenters = importer("Sagas/Centers/getAllCenters/main");
const getAllCentersSuccess = importer("Sagas/Centers/getAllCenters/success");
const getAllCentersFailure = importer("Sagas/Centers/getAllCenters/failure");

const getAppointmentCenter = importer(
  "Sagas/Centers/getAppointmentCenter/main"
);
const getAppointmentCenterSuccess = importer(
  "Sagas/Centers/getAppointmentCenter/success"
);
const getAppointmentCenterFailure = importer(
  "Sagas/Centers/getAppointmentCenter/failure"
);

const getDonorCenterInfo = importer("Sagas/Centers/getDonorCenterInfo/main");
const getDonorCenterInfoSuccess = importer(
  "Sagas/Centers/getDonorCenterInfo/success"
);
const getDonorCenterInfoFailure = importer(
  "Sagas/Centers/getDonorCenterInfo/failure"
);

const getFavoriteCenterInfo = importer(
  "Sagas/Centers/getFavoriteCenterInfo/main"
);
const getFavoriteCenterInfoSuccess = importer(
  "Sagas/Centers/getFavoriteCenterInfo/success"
);
const getFavoriteCenterInfoFailure = importer(
  "Sagas/Centers/getFavoriteCenterInfo/failure"
);

const updateFavoriteCenter = importer(
  "Sagas/Centers/updateFavoriteCenter/main"
);
const updateFavoriteCenterSuccess = importer(
  "Sagas/Centers/updateFavoriteCenter/success"
);
const updateFavoriteCenterFailure = importer(
  "Sagas/Centers/updateFavoriteCenter/failure"
);

const getAlternateDonorCentersInfo = importer(
  "Sagas/Centers/getAlternateDonorCentersInfo/main"
);
const getAlternateDonorCentersInfoSuccess = importer(
  "Sagas/Centers/getAlternateDonorCentersInfo/success"
);
const getAlternateDonorCentersInfoFailure = importer(
  "Sagas/Centers/getAlternateDonorCentersInfo/failure"
);

const getCenterInfo = importer("Sagas/Centers/getCenterInfo/main");
const getCenterInfoSuccess = importer("Sagas/Centers/getCenterInfo/success");
const getCenterInfoFailure = importer("Sagas/Centers/getCenterInfo/failure");
const getStateCenters = importer("Sagas/Centers/getStateCenters/main");
const getStateCentersSuccess = importer(
  "Sagas/Centers/getStateCenters/success"
);
const getStateCentersFailure = importer(
  "Sagas/Centers/getStateCenters/failure"
);
const getDonorCentersAll = importer("Sagas/Centers/getDonorCentersAll/main");
const getDonorCentersAllSuccess = importer(
  "Sagas/Centers/getDonorCentersAll/success"
);
const getDonorCentersAllFailure = importer(
  "Sagas/Centers/getDonorCentersAll/failure"
);

const getZipcodeSearchCenters = importer(
  "Sagas/Centers/getZipcodeSearchCenters/main"
);
const getZipcodeSearchCentersSuccess = importer(
  "Sagas/Centers/getZipcodeSearchCenters/success"
);
const getZipcodeSearchCentersFailure = importer(
  "Sagas/Centers/getZipcodeSearchCenters/failure"
);

const getAppointmentSlot = importer("Sagas/Centers/getAppointmentSlot/main");
const getAppointmentSlotSuccess = importer(
  "Sagas/Centers/getAppointmentSlot/success"
);
const getAppointmentSlotFailure = importer(
  "Sagas/Centers/getAppointmentSlot/failure"
);

const addAppointmentSlot = importer("Sagas/Centers/addAppointmentSlot/main");
const addAppointmentSlotSuccess = importer(
  "Sagas/Centers/addAppointmentSlot/success"
);
const addAppointmentSlotFailure = importer(
  "Sagas/Centers/addAppointmentSlot/failure"
);

const getSlotsForAppointmentType = importer(
  "Sagas/Centers/getSlotsForAppointmentType/main"
);
const getSlotsForAppointmentTypeSuccess = importer(
  "Sagas/Centers/getSlotsForAppointmentType/success"
);
const getSlotsForAppointmentTypeFailure = importer(
  "Sagas/Centers/getSlotsForAppointmentType/failure"
);

const getSlotsForDonor = importer("Sagas/Centers/getSlotsForDonor/main");
const getSlotsForDonorSuccess = importer(
  "Sagas/Centers/getSlotsForDonor/success"
);
const getSlotsForDonorFailure = importer(
  "Sagas/Centers/getSlotsForDonor/failure"
);

const downloadReport = importer("Sagas/Centers/downloadReport/main");
const downloadReportSuccess = importer("Sagas/Centers/downloadReport/success");
const downloadReportFailure = importer("Sagas/Centers/downloadReport/failure");

const getAppointmentReport = importer(
  "Sagas/Centers/getAppointmentReport/main"
);
const getAppointmentReportSuccess = importer(
  "Sagas/Centers/getAppointmentReport/success"
);
const getAppointmentReportFailure = importer(
  "Sagas/Centers/getAppointmentReport/failure"
);

const getCenterCalendar = importer("Sagas/Centers/getCenterCalendar/main");
const getCenterCalendarSuccess = importer(
  "Sagas/Centers/getCenterCalendar/success"
);
const getCenterCalendarFailure = importer(
  "Sagas/Centers/getCenterCalendar/failure"
);

const getCenterSlotConfig = importer("Sagas/Centers/getCenterSlotConfig/main");
const getCenterSlotConfigSuccess = importer(
  "Sagas/Centers/getCenterSlotConfig/success"
);
const getCenterSlotConfigFailure = importer(
  "Sagas/Centers/getCenterSlotConfig/failure"
);

const saveCenterSlotConfig = importer(
  "Sagas/Centers/saveCenterSlotConfig/main"
);
const saveCenterSlotConfigSuccess = importer(
  "Sagas/Centers/saveCenterSlotConfig/success"
);
const saveCenterSlotConfigFailure = importer(
  "Sagas/Centers/saveCenterSlotConfig/failure"
);

const registerGetCenters = importer("Sagas/Centers/registerGetCenters/main");
const registerGetCentersSuccess = importer(
  "Sagas/Centers/registerGetCenters/success"
);
const registerGetCentersFailure = importer(
  "Sagas/Centers/registerGetCenters/failure"
);

const createApplicationUser = importer(
  "Sagas/Centers/createApplicationUser/main"
);
const createApplicationUserSuccess = importer(
  "Sagas/Centers/createApplicationUser/success"
);
const createApplicationUserFailure = importer(
  "Sagas/Centers/createApplicationUser/failure"
);

const searchApplicationUser = importer(
  "Sagas/Centers/searchApplicationUser/main"
);
const searchApplicationUserSuccess = importer(
  "Sagas/Centers/searchApplicationUser/success"
);
const searchApplicationUserFailure = importer(
  "Sagas/Centers/searchApplicationUser/failure"
);

const getApplicationUserDetails = importer(
  "Sagas/Centers/getApplicationUserDetails/main"
);
const getApplicationUserDetailsSuccess = importer(
  "Sagas/Centers/getApplicationUserDetails/success"
);
const getApplicationUserDetailsFailure = importer(
  "Sagas/Centers/getApplicationUserDetails/failure"
);

const editApplicationUser = importer("Sagas/Centers/editApplicationUser/main");
const editApplicationUserSuccess = importer(
  "Sagas/Centers/editApplicationUser/success"
);
const editApplicationUserFailure = importer(
  "Sagas/Centers/editApplicationUser/failure"
);

const removeUserCenterAccess = importer(
  "Sagas/Centers/removeUserCenterAccess/main"
);
const removeUserCenterAccessSuccess = importer(
  "Sagas/Centers/removeUserCenterAccess/success"
);
const removeUserCenterAccessFailure = importer(
  "Sagas/Centers/removeUserCenterAccess/failure"
);

const updateUserDefaultCenter = importer(
  "Sagas/Centers/updateUserDefaultCenter/main"
);
const updateUserDefaultCenterSuccess = importer(
  "Sagas/Centers/updateUserDefaultCenter/success"
);
const updateUserDefaultCenterFailure = importer(
  "Sagas/Centers/updateUserDefaultCenter/failure"
);

const removeUserPortalAccess = importer(
  "Sagas/Centers/removeUserPortalAccess/main"
);
const removeUserPortalAccessSuccess = importer(
  "Sagas/Centers/removeUserPortalAccess/success"
);
const removeUserPortalAccessFailure = importer(
  "Sagas/Centers/removeUserPortalAccess/failure"
);

const addUserCenterAccess = importer("Sagas/Centers/addUserCenterAccess/main");
const addUserCenterAccessSuccess = importer(
  "Sagas/Centers/addUserCenterAccess/success"
);
const addUserCenterAccessFailure = importer(
  "Sagas/Centers/addUserCenterAccess/failure"
);

export default {
  registerGetCenters,
  registerGetCentersSuccess,
  registerGetCentersFailure,

  getDonorCenterInfo,
  getDonorCenterInfoSuccess,
  getDonorCenterInfoFailure,

  getFavoriteCenterInfo,
  getFavoriteCenterInfoSuccess,
  getFavoriteCenterInfoFailure,

  updateFavoriteCenter,
  updateFavoriteCenterSuccess,
  updateFavoriteCenterFailure,

  getAlternateDonorCentersInfo,
  getAlternateDonorCentersInfoSuccess,
  getAlternateDonorCentersInfoFailure,

  getCenterInfo,
  getCenterInfoSuccess,
  getCenterInfoFailure,

  getAllCenters,
  getAllCentersSuccess,
  getAllCentersFailure,

  getZipcodeSearchCenters,
  getZipcodeSearchCentersSuccess,
  getZipcodeSearchCentersFailure,

  getAppointmentCenter,
  getAppointmentCenterSuccess,
  getAppointmentCenterFailure,

  getDonorCentersAll,
  getDonorCentersAllSuccess,
  getDonorCentersAllFailure,

  getAppointmentSlot,
  getAppointmentSlotSuccess,
  getAppointmentSlotFailure,

  addAppointmentSlot,
  addAppointmentSlotSuccess,
  addAppointmentSlotFailure,

  getSlotsForAppointmentType,
  getSlotsForAppointmentTypeSuccess,
  getSlotsForAppointmentTypeFailure,

  getSlotsForDonor,
  getSlotsForDonorSuccess,
  getSlotsForDonorFailure,

  downloadReport,
  downloadReportSuccess,
  downloadReportFailure,

  getAppointmentReport,
  getAppointmentReportSuccess,
  getAppointmentReportFailure,

  getCenterCalendar,
  getCenterCalendarSuccess,
  getCenterCalendarFailure,

  getCenterSlotConfig,
  getCenterSlotConfigSuccess,
  getCenterSlotConfigFailure,

  saveCenterSlotConfig,
  saveCenterSlotConfigSuccess,
  saveCenterSlotConfigFailure,

  createApplicationUser,
  createApplicationUserSuccess,
  createApplicationUserFailure,

  searchApplicationUser,
  searchApplicationUserSuccess,
  searchApplicationUserFailure,

  getApplicationUserDetails,
  getApplicationUserDetailsSuccess,
  getApplicationUserDetailsFailure,

  editApplicationUser,
  editApplicationUserSuccess,
  editApplicationUserFailure,

  removeUserCenterAccess,
  removeUserCenterAccessSuccess,
  removeUserCenterAccessFailure,

  updateUserDefaultCenter,
  updateUserDefaultCenterSuccess,
  updateUserDefaultCenterFailure,

  removeUserPortalAccess,
  removeUserPortalAccessSuccess,
  removeUserPortalAccessFailure,

  addUserCenterAccess,
  addUserCenterAccessSuccess,
  addUserCenterAccessFailure,

  getStateCenters,
  getStateCentersSuccess,
  getStateCentersFailure,
};
